import React from 'react';
import Card from '../../controls/Card';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { EOPDRegisteredStatusBg, GetEOPDRegisterStatusName } from '../../../configurations/enums/EOPDRegisteredStatus';
import StatusContainer from '../../controls/StatusContainer';
import { EOPDConfirmedStatusBg, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus';

const MyConfirmCard = ({ item }) => {
    return (
        <Link to={'/checkconfirmed/' + item.id}>
            <Card
                title={
                    <div className="w-full flex items-center justify-between mb-2">
                        <div className="flex items-center gap-4">
                            {/* Tonal Avatar - Material 'Initial' Style */}
                            <div className="w-16 h-16 rounded-2xl bg-indigo-100 flex items-center justify-center text-indigo-700 text-xl font-bold">
                                {item.patientName.split(" ").map((n) => n[0]).join("").slice(0, 2)}
                            </div>
                            <div>
                                <h3 className="text-xl font-bold text-slate-900">{item.patientName}</h3>
                                <p className="text-sm text-slate-500 font-medium">#ID: {item.id}</p>
                                <p className="text-xs text-green-500 font-medium">OPD No: {item.confirmedAllotedNumber}</p>
                                <p className="text-xs text-slate-500 font-medium">Date: {moment(item.onDate).format("MMM DD, YYYY")}</p>
                            </div>
                        </div>
                        <div className="flex flex-col items-end">
                            <StatusContainer
                                bg={EOPDConfirmedStatusBg(item.status)}
                                text={GetEOPDConfirmedStatusName(item.status)}
                            />
                        </div>
                    </div>
                }
                isBorder={true}
            >
                <div className="grid grid-cols-2 gap-3">
                    <div className="p-4 rounded-2xl border border-slate-100 bg-slate-100">
                        <p className="text-[10px] uppercase tracking-wider font-bold text-slate-400 mb-1">Doctor</p>
                        <p className="text-sm font-semibold text-slate-800">{item.user.fullName} <span className="text-sm font-normal text-slate-500">{item.user.degree}</span></p>
                    </div>
                    <div className="p-4 rounded-2xl border border-slate-100 bg-slate-100">
                        <p className="text-[10px] uppercase tracking-wider font-bold text-slate-400 mb-1">Specialisation</p>
                        <p className="text-sm font-semibold text-slate-800">{item.user.specialisation.name}</p>
                    </div>
                </div>

                {/* Detailed Info List */}
                <div className="space-y-4">
                    <div className="flex justify-between items-center py-2">
                        <span className="text-sm text-slate-500">Opd Center</span>
                        <span className="text-sm font-medium text-slate-800">
                            {item.opdCenter.centerName}
                        </span>
                    </div>
                </div>
            </Card>
        </Link>
    );
};

export default MyConfirmCard;